export default "  // empty\n";
//# sourceMappingURL=lighting-common.glsl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/shadertools/modules/lighting/lighting-common.glsl.js
// module id = 779
// module chunks = 0